// extracted by mini-css-extract-plugin
export default {"pegButton":"PegButton_pegButton__zRYDd","peg":"PegButton_peg__cyudd"};